import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RecordingsListService } from './recordings.service';
import { RecordingListItem } from './interfaces/recording-list-item.interface';
import { bcStates } from 'common/common/states';
import { StateServiceWrapper } from 'shared/services/state-service-wrapper/state-service-wrapper';
// Using relative path so it works within the guide, too
import * as moment from '../../../../node_modules/moment/moment'; // eslint-disable-line import/no-internal-modules
import { BcAnalytics } from 'common/analytics/analytics.service';
import { BcConfigService } from 'common/config/provider';
import { CommonAuthService } from 'common/auth/common-auth.service';

@Component({
  selector: 'app-recordings',
  templateUrl: './recordings.component.html',
  styleUrls: ['./recordings.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RecordingsComponent implements OnInit {
  public recordingsList: RecordingListItem[] = [];
  public moment;

  constructor(private listService: RecordingsListService,
              private bcAnalytics: BcAnalytics,
              public config: BcConfigService,
              private stateService: StateServiceWrapper,
              private _commonAuth: CommonAuthService) {
    this.moment = moment;
  }

  async ngOnInit() {
    if (await this._commonAuth.isBoldEnabled()) {
      this.initRecordingList().catch((err) => {
        throw new Error('Couldn\'t load recording history: ' + err);
      });
    }
  }

  async initRecordingList() {
    this.recordingsList = await this.listService.loadRecordings();
  }

  get isRecordingListEmpty() {
    return this.recordingsList.length === 0;
  }

  navigateToWorkspace(): void {
    this.stateService.go(bcStates.layout.url);
  }

  trackRecordingDownload() {
    this.bcAnalytics.eventTrack('DownloadRCRecording');
  }
}
